import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-wrap gap-2',
    header:
      'mb-4.5 flex w-full items-center justify-between font-medium max-lg:cursor-pointer',
    label: 'flex items-center gap-2',
    chevron: 'block rotate-0 transition-transform',
    options: 'mt-3 mb-10 flex flex-col gap-6',
    collapse: ''
  },
  variants: {
    collapse: {
      false: {
        chevron: 'rotate-180',
        collapse: '!max-h-max'
      }
    }
  }
});
